import React, { useState } from 'react'
import '../styles/InstructionVideoComponent.css'
import { videoList, instructionVideos } from '../constants/Constants'
import { useTranslation } from 'react-i18next'

function InstructionVideoComponent() {
    const { t } = useTranslation()
    const [videoNumber, setVideoNumber] = useState(0)
    const [isPlaying, setIsPlaying] = useState(false)

    const toggleInstructionVideo = () => {
        if (!isPlaying) setIsPlaying(!isPlaying)
    }

    const handlePrevious = () => {
        if (videoNumber > 0) {
            setVideoNumber((prev) => prev - 1)
            setIsPlaying(false)
        }
    }
    const handleNext = () => {
        if (videoNumber < instructionVideos.length - 1) {
            setVideoNumber((prev) => prev + 1)
            setIsPlaying(false)
        }
    }

    const videoData = instructionVideos[videoNumber]

    return (
        <div className="instruction-video-wrapper">
            <div className="instruction-video-title">{t(videoData.title)}</div>
            <div className="instruction-video-subtitle">{t(videoData.description)}</div>
            <div className="instruction-video-container" onClick={toggleInstructionVideo}>
                {!isPlaying ? (
                    <img src={videoData.img} className="profile-logo" alt="Be Amazing" height={330} />
                ) : (
                    <div className="instruction-video-inner-container">
                        <video controls controlsList="nodownload" autoPlay={true}>
                            <source src={videoData.url} />
                            {t('yourBrowserDoesNotSupportHTMLVideo')}
                        </video>
                    </div>
                )}
            </div>
            <div className="instruction-video-buttons">
                <button className={`instruction-previus-button ${videoNumber > 0 ? 'previous-has-more' : 'previous-no-more'}`} onClick={handlePrevious}>
                    {t('Previous')}
                </button>
                <button className={`instruction-next-button ${videoList.length - 1 > videoNumber ? 'next-has-more' : 'next-no-more'}`} onClick={handleNext}>
                    {t('Next Video')}
                </button>
            </div>
        </div>
    )
}

export default InstructionVideoComponent
